import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/skills')({
  component: SkillsPage,
});

function SkillsPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Skills</h1>
      <p className="text-muted-foreground">
        Manage skills and competencies database. This page is under development.
      </p>
    </div>
  );
}
